import { render, staticRenderFns } from "./AssignmentComment.vue?vue&type=template&id=4f21c36c"
import script from "./AssignmentComment.vue?vue&type=script&lang=js"
export * from "./AssignmentComment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports